export const GOLF_CATEGORIES = [
  {
    id: 'championship',
    name: 'Campeonato',
    handicapMin: -1.2,
    handicapMax: 3.7
  },
  {
    id: 'aa',
    name: 'AA',
    handicapMin: 3.8,
    handicapMax: 7.1
  },
  {
    id: 'a',
    name: 'A',
    handicapMin: 7.2,
    handicapMax: 10.8
  },
  {
    id: 'b',
    name: 'B',
    handicapMin: 10.9,
    handicapMax: 16.0
  },
  {
    id: 'c',
    name: 'C',
    handicapMin: 16.1,
    handicapMax: 20.2
  },
  {
    id: 'd',
    name: 'D',
    handicapMin: 20.3,
    handicapMax: 33.1
  },
  {
    id: 'senior',
    name: 'Senior (+65)',
    handicapMin: null,
    handicapMax: null
  }
]

export const GAME_SYSTEMS = [
  {
    id: 'stroke_play',
    name: 'Stroke Play Bola Baja'
  },
  {
    id: 'stableford',
    name: 'Stableford'
  },
  {
    id: 'alternate_shot',
    name: 'Golpe Alterno'
  },
  {
    id: 'a_go_go',
    name: 'A Go-Go'
  }
]

export const getCategoryById = (categoryId) => {
  return GOLF_CATEGORIES.find(cat => cat.id === categoryId)
}

export const getGameSystemById = (systemId) => {
  return GAME_SYSTEMS.find(sys => sys.id === systemId)
}
